import React from 'react';
import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';

import style from './index.less';

const MessagePhotoCard = props => {
  const { data = {} } = props;
  const { pic_url, target_url } = data;
  const safeUrl = filterBlackList(removeHTMLScript(target_url));

  return (
    <React.Fragment>
      <a target="_blank" rel="noopener noreferrer" href={safeUrl}>
        <img src={pic_url} alt="" className={style['photo-card']} />
      </a>
    </React.Fragment>
  );
};

export default MessagePhotoCard;
